import MixpanelTracker from '../mixpanelTracker';
import Action from '../Model/action';
import { ON_REGISTER_USER, ON_REGISTER_USER_STATUS } from '../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function onRegisterUserTracker(userData) {
  const properties = {
    Action: Action.ADD,
    userData,
  };
  mixpanelTracker.setEventName(ON_REGISTER_USER);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onSuccessRegisterUserTracker(
  userData,
  noOfNonMandatoryQuestion,
  noOfNonMandatoryQuestionAnswered,
  noOfNonMandatoryQuestionAnsweredInPercent,
  totalNoOfQuestion,
  totalnoOfTemplateQuestion,
  totalnoOfCustomQuestion,
  description,
) {
  const properties = {
    Action: Action.ADD,
    userData,
    noOfNonMandatoryQuestion,
    noOfNonMandatoryQuestionAnswered,
    noOfNonMandatoryQuestionAnsweredInPercent,
    totalNoOfQuestion,
    totalnoOfTemplateQuestion,
    totalnoOfCustomQuestion,
    description,
  };
  mixpanelTracker.setEventName(ON_REGISTER_USER_STATUS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onFailureRegisterUserTracker(
  userData,
  noOfNonMandatoryQuestion,
  noOfNonMandatoryQuestionAnswered,
  noOfNonMandatoryQuestionAnsweredInPercent,
  totalNoOfQuestion,
  totalnoOfTemplateQuestion,
  totalnoOfCustomQuestion,
  description,
) {
  const properties = {
    Action: Action.ADD,
    userData,
    noOfNonMandatoryQuestion,
    noOfNonMandatoryQuestionAnswered,
    noOfNonMandatoryQuestionAnsweredInPercent,
    totalNoOfQuestion,
    totalnoOfTemplateQuestion,
    totalnoOfCustomQuestion,
    description,
  };
  mixpanelTracker.setEventName(ON_REGISTER_USER_STATUS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
